<app-header></app-header>
<app-side-nav>
  <router-outlet></router-outlet>
</app-side-nav>
<app-footer></app-footer>
